<template>
  <div>
    <Head :title="title" />
    <div class="mb-6 flex justify-between items-center">
      <search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-input>
      <Link class="btn-indigo" :href="route('ticket-departments.create')">
        <span>{{ __('Create New') }}</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4"></th>
          <th class="px-6 pt-6 pb-4">Nombre</th>
          <th class="px-6 pt-6 pb-4">Categorías vinculadas</th>
          <th class="px-6 pt-6 pb-4">Responsables</th>
        </tr>
        <tr v-for="ticketDepartment in ticket_departments.data" :key="ticketDepartment.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t w-px">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('ticket-departments.edit', ticketDepartment.id)">
              <icon v-if="ticketDepartment.icon" :name="ticketDepartment.icon" class="w-6 h-6 fill-gray-500" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('ticket-departments.edit', ticketDepartment.id)">
              {{ ticketDepartment.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('ticket-departments.edit', ticketDepartment.id)">
              {{ ticketDepartment.categories_count }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('ticket-departments.edit', ticketDepartment.id)">
              {{ ticketDepartment.responsibles_count }}
            </Link>
          </td>
          <td class="border-t w-px">
            <Link class="px-4 flex items-center" :href="route('ticket-departments.edit', ticketDepartment.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="ticket_departments.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encontraron departamentos.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="ticket_departments.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import { Link, Head } from '@inertiajs/inertia-vue3'

export default {
  metaInfo: { title: 'Departamentos' },
  components: {
    SearchInput,
    Icon,
    Pagination,
    Link,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    filters: Object,
    ticket_departments: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('ticket-departments'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
